"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var material_ui_image_1 = require("material-ui-image");
var core_1 = require("@material-ui/core");
var financeSectionStyles_1 = require("./financeSectionStyles");
var Translation_1 = require("../../../../common/components/presentation/Translation/Translation");
var BackToFinanceButton_1 = require("../../../common/components/steps/backToFinanceButton/BackToFinanceButton");
var useCheckoutContext_1 = require("../../../common/hooks/useCheckoutContext");
var ContinueButton_1 = require("../buttons/continueButton/ContinueButton");
var FinanceSection = function () {
    var _a, _b;
    var styles = financeSectionStyles_1.default();
    var deal = useCheckoutContext_1.default().deal;
    var image = (_a = deal) === null || _a === void 0 ? void 0 : _a.car.images[0].url;
    return (<core_1.Grid container spacing={2} data-test={'checkout:finance_section'} className={styles.financeWrapper}>
      <core_1.Grid item sm={12} md={6}>
        <material_ui_image_1.default src={image} color="transparent" className={styles.image} imageStyle={{ position: 'unset', height: 'auto' }} style={{ paddingTop: 0, position: 'unset' }} animationDuration={0} data-test={'checkout:finance_section:image'} iconContainerStyle={{ position: 'unset' }}/>
      </core_1.Grid>
      <core_1.Grid item sm={12} md={6} className={styles.financeDetails}>
        <core_1.Typography variant={'h4'} data-test={'checkout:finance_section:title'}>
          <Translation_1.default id={'trans__checkout__extras_page__finance_title'} className={styles.title}/>
        </core_1.Typography>
        <core_1.Typography data-test={'checkout:finance_section:details'}>
          <Translation_1.default id={'trans__checkout__extras_page__finance_description'} className={styles.details}/>
        </core_1.Typography>
        <core_1.Box className={styles.backToFinanceButtonContainer}>
          <BackToFinanceButton_1.default carConfigurationUrl={(_b = deal) === null || _b === void 0 ? void 0 : _b.car.configurationSourceUrl}/>
        </core_1.Box>
      </core_1.Grid>
      <core_1.Grid item sm={12}>
        <core_1.Box className={styles.continueButtonContainer}>
          <ContinueButton_1.default testId="checkout:continue_button:finance" activateNextStep={true}/>
        </core_1.Box>
      </core_1.Grid>
    </core_1.Grid>);
};
exports.default = FinanceSection;
